import React from 'react'
import { Col } from "antd";

const GeoLocationListing: React.FC<{
    barChart: string;
}> = ({ barChart }) => {
    return (
        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={8}>
            <div className="dashboardChartCard">
                <div className="dashboardCard mainChartWidget">
                    <div className="chartTopbar">
                        <h5>Listing Based on Geo Location</h5>
                    </div>
                    {/* <div className="chartBody">
                        <div>
                            <img
                                src={barChart}
                                alt=""
                                style={{ width: "95%" }}
                            />
                        </div>
                    </div> */}
                    <div className='comingsoon comingsoonLrg' style={{height:250}}></div>

                </div>
            </div>
        </Col>
    )
}

export default GeoLocationListing